import axios from "axios";
import React, { FC, createContext, useContext, useState, useEffect } from "react";

import { SocketContext, TeamContext } from "../context";

import { IAlertnotification, IPlayer } from "../interfaces";
import { setPlayersInTheNewOrder } from "./helpers";

interface IUserConext {
	userData?: IPlayer;
	notificationAlert?: IAlertnotification;
	activateAlert: boolean;
	emailOfSelectedPlayerBoard: any;
	mailExists: boolean;
	playersInNewOrder: IPlayer[];
	currentlyInputedUserData: any;
	createUser(userData: IPlayer): void;
	notificationSendEmail(userEmail: string, matchId: string, message: string): void;
	doesEmailExist(userEmail: string): void;
	setUserStatus(): void;
	joinLobby(payload: any): void;
	joinTeamLobby(payload: any): void;
	changePlayerStatusSocketEvent(): void;
	setNotificationAlert(notificationAlert: IAlertnotification): void;
	setActivateAlert(activateAlert: boolean): void;
	changeTeamNickNameSocketEmit(newTeamName: string): void;
	changePlayerNickNameSocketEmit(newPlayerNickName: string): void;
	setEmailOfSelectedPlayerBoard(emailOfSelectedPlayerBoard: any): void;
	setUserDataWhenUserRejoinsTheGame(email: string): void;
	setUserData(userData: any): void;
	setMailExists(mailExists: boolean): void;
}

const UserContext = createContext({} as IUserConext);

interface UserContextProps {
	children: React.ReactNode;
}

const UserContextProvider: FC<UserContextProps> = (props) => {
	const { socket } = useContext(SocketContext);
	const { game } = useContext(TeamContext);
	const [userData, setUserData] = useState<IPlayer | undefined>();
	const [notificationAlert, setNotificationAlert] = useState<IAlertnotification>();
	const [activateAlert, setActivateAlert] = useState<boolean>(false);
	const [currentlyInputedUserData, setCurrentlyInputedUserData] = useState();
	const [emailOfSelectedPlayerBoard, setEmailOfSelectedPlayerBoard] = useState<string>("");
	const [playersInNewOrder, setPlayersInNewOrder] = useState<IPlayer[]>(setPlayersInTheNewOrder(game?.players, userData));
	const [mailExists, setMailExists] = useState<boolean>(false);

	useEffect(() => {
		setPlayersInNewOrder(setPlayersInTheNewOrder(game?.players, userData));
	}, [game, userData]);

	const createUser = (userData: IPlayer) => {
		setUserData(userData);
		setEmailOfSelectedPlayerBoard(userData.email)
	};

	const notificationSendEmail = (userEmail: string, matchId: string, message: string) => {
		axios({
			method: "post",
			// url: process.env.REACT_APP_BACKEND_URL_ADMIN + "api/notifications/send-email",
			url: process.env.REACT_APP_ADMIN_BACKEND_URL + "api/notifications/send-email",
			
			// url: "http://admin-api.uppiness.marbleit.rs/api/notifications/send-email",
			data:{
				playerEmail: userEmail,
				matchId:matchId,
				text: message
			}
			})
			.then((res: any) => {
				console.log(res);
			})
			.catch((err: any) => console.error(err));
	}

	const setUserDataWhenUserRejoinsTheGame = (email: string) => {

		let user;
		const player = game?.players.find((item: any) => { return item.email === email });
		const lobbyPlayer = game?.inGameLobby?.find((item: any) => { return item.email === email });
		if(!player){
			setUserData({
				color: lobbyPlayer?.color || "",
				fullName: lobbyPlayer?.nickname || "",
				nickname: lobbyPlayer?.nickname,
				email: email,
				image: lobbyPlayer?.image || "",
				isReady: true,
			})
		} else {
			setUserData({
				color: player?.color || "",
				fullName: player?.fullName || "",
				nickname: player?.nickname,
				email: email,
				image: player?.image || "",
				isReady: true,
			})
		}

		setEmailOfSelectedPlayerBoard(email);
		
	}

	const changePlayerStatusSocketEvent = () => {
		socket?.emit("changePlayerStatus");
	}

	const changeTeamNickNameSocketEmit = (newTeamName: string) => {
		socket?.emit("changeTeamNickName", { nickname: newTeamName });
	}

	const changePlayerNickNameSocketEmit = (newPlayerNickName: string) => {
		socket?.emit("changePlayerNickName", { nickname: newPlayerNickName });
	}

	const setUserStatus = () => {
		setUserData({
			...userData!,
			isReady: !userData?.isReady,
		});
	};

	const joinLobby = (payload: any) => {
		socket?.emit("joinRoom", payload);
		setCurrentlyInputedUserData(payload);
	};

	const joinTeamLobby = (payload: any) => {
		socket?.emit("joinTeamRoom", payload);
	}


	const doesEmailExist = (userEmail: string) => {
		axios({
			method: "get",
			url: process.env.REACT_APP_BACKEND_URL + `api/matches/does-email-exists/${userEmail}`
			})
			.then((res: any) => {
				setMailExists(res.data.isAlreadyUsed);
			})
			.catch((err: any) => console.error(err));
	}

	const providerValue = {
		userData,
		notificationAlert,
		activateAlert,
		emailOfSelectedPlayerBoard,
		mailExists,
		playersInNewOrder,
		currentlyInputedUserData,
		createUser,
		notificationSendEmail,
		doesEmailExist,
		setUserStatus,
		joinLobby,
		changePlayerStatusSocketEvent,
		setNotificationAlert,
		setActivateAlert,
		setMailExists,
		joinTeamLobby,
		changeTeamNickNameSocketEmit,
		changePlayerNickNameSocketEmit,
		setEmailOfSelectedPlayerBoard,
		setUserDataWhenUserRejoinsTheGame,
		setUserData
	};

	return (
		<UserContext.Provider value={providerValue}>
			{props.children}
		</UserContext.Provider>
	);
};

export { UserContext, UserContextProvider };
